export default __webpack_public_path__ + "static/media/graphic-1.70deeb1d.png";